import { List } from "immutable";

import { AccessorRole } from "seneca-common/features/class/state";

import { ClassTeacherType } from "../../models/ClassTeacher";

export function getSortedTeacherNames(teachers: List<ClassTeacherType>) {
  return (
    teachers
      .toList()
      // push owners to the start of the list
      .sort((a: any, b: any) => (a.role === AccessorRole.owner ? -1 : 0))
      .map(teacher => teacher.name)
  );
}
